// src/pages/notificationstab/Notifications.jsx
import React, { useState, useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { axiosInstance } from '../../config';
import './Notifications.css';
import { AuthContext } from '../../context/AuthContext';

function ArrowLeftIcon({ size = 18 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M15 18l-6-6 6-6" />
    </svg>
  );
}

const Notifications = () => {
  const { user: currentUser, dispatch } = useContext(AuthContext);
  const loc = useLocation();
  const nav = useNavigate();

  const [settings, setSettings] = useState({
    email: true,
  });

  /* ---- SMART BACK (matches your other pages) ---- */
  const goBackToForYou = () => {
    const backTo = loc.state?.backTo;
    if (backTo) return nav(backTo, { replace: true });
    if (window.history.length > 1) return nav(-1);
    nav(`/`, { replace: true });
  };

  // Load current notification settings
  useEffect(() => {
    const loadSettings = async () => {
      if (currentUser) {
        try {
          // Default to true when field doesn't exist yet
          const emailEnabled = currentUser.emailNotifications !== false;
          setSettings((prev) => ({
            ...prev,
            email: emailEnabled,
          }));
        } catch (error) {
          console.error('Failed to load notification settings:', error);
        }
      }
    };

    loadSettings();
  }, [currentUser]);

  const toggleSetting = async (type) => {
    const newValue = !settings[type];
    setSettings((prev) => ({
      ...prev,
      [type]: newValue,
    }));

    try {
      const response = await axiosInstance.post(`/notifications/toggle-${type}`, {
        enabled: newValue,
        userId: currentUser?._id,
      });

      if (response.status === 200) {
        // Update the user context with the new email notifications setting
        if (type === 'email') {
          dispatch({
            type: 'UPDATE_EMAIL_NOTIFICATIONS',
            payload: newValue,
          });
        }
      }
    } catch (error) {
      console.error(`Failed to toggle ${type}:`, error);
      console.error('Error details:', error.response?.data);
      // Revert on failure
      setSettings((prev) => ({
        ...prev,
        [type]: !newValue,
      }));
    }
  };

  return (
    <div className="streaming-page">
      {/* Top back bar (shared style) */}
      <header className="page-topbar">
        <button
          type="button"
          className="topbar-back"
          aria-label="Back"
          onClick={goBackToForYou}
        >
          <ArrowLeftIcon />
        </button>
        <div className="page-topbar-title">Notifications</div>
      </header>

      {/* Content */}
      <div className="notifications-container">
        <h1 className="notifications-title">NOTIFICATIONS</h1>

        <div className="notifications-setting">
          <div className="setting-header">
            <div className="setting-title">VIA EMAIL</div>
            <div
              className={`toggle-switch ${!settings.email ? 'off' : ''}`}
              onClick={() => toggleSetting('email')}
              role="switch"
              aria-checked={settings.email}
              aria-label="Toggle email notifications"
            />
          </div>
          <div className="setting-description">
            RECEIVE NOTIFICATION THROUGH EMAIL
          </div>
        </div>
      </div>

      <div className="notifications-footer">
        <div className="footer-text">
          {/* © {new Date().getFullYear()} YZY STREAMING, ALL RIGHTS RESERVED. */}
        </div>
      </div>
    </div>
  );
};

export default Notifications;
